import { registerQuery } from '@adornis/baseql/metadata/register.js';
import type { BaseQLSelectionSet } from '@adornis/baseql/utils/queryGeneration.js';
import { MailProcessing } from '../db/MailExtractionResult.js';
import { getMailProcessing } from './getMailProcessing.js';

export const ensureMailProcessing = registerQuery({
  type: () => MailProcessing,
  operationName: 'ensureMailProcessing',
  resolve: (mailID: string) => {
    return async (gqlFields: BaseQLSelectionSet<MailProcessing>) => {
      // check if a MailProcessing already exists for the given mailID
      const mailProcessing = await getMailProcessing(mailID)(gqlFields);
      if (mailProcessing) return mailProcessing;
      // if not, create a new one with empty extraction result
      const newMailProcessing = new MailProcessing({
        mailID,
      });
      newMailProcessing._id = await newMailProcessing.create();
      return newMailProcessing;
    };
  },
  params: [{ name: 'mailID', type: () => String }],
});
